import { clsx, type ClassValue } from "clsx"
import { extendTailwindMerge } from "tailwind-merge"

/**
 * Dimensiunile de font proprii, din `@theme` si din `@utility` in `main.css`.
 *
 * ⚠️ Lista asta NU e cosmetica. Fara ea, `tailwind-merge` nu stie ca
 * `text-small` e o DIMENSIUNE: cade pe validatorul generic al grupului
 * `text-color`, care accepta orice sir. Doua clase din acelasi grup =
 * castiga ultima, deci `cn('bg-dark text-white', 'text-small')` STERGE
 * `text-white` si textul ramane pe culoarea mostenita.
 *
 * S-a intamplat de doua ori in acest repo:
 *   1. `text-medium`, documentat in
 *      docs/knowledge/verificarea-in-browser-bate-reviewul-pe-diff.md;
 *   2. `text-small` pe `ActionButton`, unde 5 din 8 variante randau text
 *      invizibil — `process` la contrast 1,00, adica text si fundal identice.
 *      Build verde, teste verzi, diff care „arata bine".
 *
 * Sens invers, la fel de tacut: `cn('text-small', 'text-error')` elimina
 * `text-small` si dimensiunea ramane cea veche.
 *
 * Orice `--text-*` nou in `@theme`, sau orice `@utility text-*` care seteaza
 * `font-size`, trebuie adaugat AICI. Testul din `utils.test.ts` e dovada ca
 * mecanismul chiar ruleaza.
 */
const DIMENSIUNI_DE_FONT = [
  // @theme --text-*
  'very-small', 'smaller', 'small', 'medium', 'large', 'larger',
  'very-large', 'extra-large',
  'chart-rank', 'chart-name', 'chart-value', 'chart-axis',
  'stat', 'stat-hero',
  // @utility text-* care seteaza font-size
  'fluid-sm', 'fluid-base', 'fluid-lg', 'fluid-xl', 'fluid-2xl',
] as const

const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [{ text: [...DIMENSIUNI_DE_FONT] }],
    },
  },
})

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
